module.exports = __webpack_public_path__ + "img/shuzirentitle.fcbb62a0.png";